import { inject, Injectable } from '@angular/core';

import { HttpApiService } from '@core/http-legacy';

import { TellentAdminRequestData } from './../lib/tellent-admin-request-data';

@Injectable({ providedIn: 'root' })
export class TellentHttpApiService extends HttpApiService {
  constructor() {
    const httpRequestData = inject(TellentAdminRequestData);
    super(httpRequestData);
  }
}
